import React from 'react';
import {
  Box,
  Container,
  IconButton,
  Paper,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Images from '../../../Configs/images';

export default function Navigator({
  title, secondaryBtn, onBack, noBorder,
}) {
  const navigate = useNavigate();

  return (
    <Paper
      sx={{
        boxShadow: 'none',
        border: noBorder ? 'none' : '1px solid #E5E5E5',
        borderTop: 'none',
        borderRadius: 0,
      }}
      className="sticky"
    >
      <Container>
        <Box display="flex" alignItems="center" justifyContent="space-between" py={1}>
          <Box flex={1}>
            <IconButton onClick={() => {
              if (onBack) {
                onBack();
              } else navigate(-1);
            }}
            >
              <img src={Images.ArrowBack} alt="arrow back" />
            </IconButton>
          </Box>
          <Box className="weight-700">{title || null}</Box>
          <Box flex={1} display="flex" justifyContent="flex-end">
            {secondaryBtn || null}
          </Box>
        </Box>
      </Container>
    </Paper>
  );
}
